import { Component, OnInit, Input } from '@angular/core';

@Component({
    selector: 'app-color-line-legend',
    templateUrl: './color-line-legend.component.html',
    styleUrls: ['./color-line-legend.component.scss'],
    standalone: false
})
export class ColorLineLegendComponent implements OnInit {

  @Input() color: string;
  @Input() borderColor: string;
  @Input() text: string;
  @Input() doNotTranslate: string;
  @Input() type = 'circle-line'; // circle || square || line || circle-line
  @Input() disabled = false;
  @Input() reportView = false;
  @Input() showColorLabel = true;

  constructor() { }

  ngOnInit() { }

}
